module.exports = __webpack_public_path__ + "img/t4.f829edeb.svg";